<div class="login-wrapper">
    <!-- Animated Background -->
    <div class="login-bg">
        <div class="bg-gradient"></div>
        <div class="bg-pattern"></div>
        <div class="floating-shapes">
            <div class="shape shape-1"></div>
            <div class="shape shape-2"></div>
            <div class="shape shape-3"></div>
            <div class="shape shape-4"></div>
            <div class="shape shape-5"></div>
        </div>
    </div>

    <!-- Login Card -->
    <div class="login-card" [class.shake]="loginError">
        <!-- Logo / Brand -->
        <div class="login-brand">
            <div class="brand-img-container" style="margin: 0 auto 16px; text-align: center;">
                <img src="assets/img/AMT.png" alt="AMT Logo" style="height: 80px; width: auto; object-fit: contain;">
            </div>
            <h1>AMT</h1>
            <p class="brand-tagline">Machine Tools Management</p>
        </div>

        <!-- Divider -->
        <div class="login-divider">
            <span>Sign In</span>
        </div>

        <!-- Login Form -->
        <form [formGroup]="loginForm" (ngSubmit)="loginDetails()" class="login-form">
            <!-- Username Field -->
            <div class="form-field" [class.focused]="usernameFocused"
                [class.has-value]="loginForm.get('username')?.value">
                <div class="field-icon">
                    <i class="fas fa-user"></i>
                </div>
                <div class="field-input">
                    <label for="username">User Name</label>
                    <input id="username" formControlName="username" type="text" autocomplete="username"
                        (focus)="usernameFocused = true" (blur)="usernameFocused = false" />
                </div>
            </div>

            <!-- Password Field -->
            <div class="form-field" [class.focused]="passwordFocused"
                [class.has-value]="loginForm.get('password')?.value">
                <div class="field-icon">
                    <i class="fas fa-lock"></i>
                </div>
                <div class="field-input">
                    <label for="password">Password</label>
                    <input id="password" formControlName="password" [type]="showPassword ? 'text' : 'password'"
                        autocomplete="current-password" (focus)="passwordFocused = true"
                        (blur)="passwordFocused = false" />
                </div>
                <button type="button" class="toggle-password" (click)="showPassword = !showPassword" tabindex="-1">
                    <i [class]="showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
                </button>
            </div>

            <!-- Error Message -->
            <div class="login-error" *ngIf="loginError">
                <i class="fas fa-exclamation-circle"></i>
                <span>Invalid username or password</span>
            </div>

            <!-- Login Button -->
            <button type="submit" class="login-btn" [class.loading]="isAuthLoading" [disabled]="isAuthLoading">
                <span class="btn-text" *ngIf="!isAuthLoading">
                    <i class="fas fa-sign-in-alt"></i> Login
                </span>
                <span class="btn-loader" *ngIf="isAuthLoading">
                    <div class="spinner"></div>
                    Authenticating...
                </span>
            </button>
        </form>

        <!-- Footer -->
        <div class="login-footer d-flex flex-column align-items-center w-100 mt-4 pt-3"
            style="border-top: 1px solid rgba(255, 255, 255, 0.06); gap: 6px;">
            <p class="text-center m-0 w-100"
                style="font-size: 11px; color: rgba(255, 255, 255, 0.5); letter-spacing: 0.3px;">&copy; 2026 Aathreya
                Machine Tools. All rights reserved.</p>
            <p class="text-center m-0 w-100"
                style="font-size: 11px; color: rgba(255, 255, 255, 0.5); letter-spacing: 0.3px;">Designed &
                Developed by <a href="https://www.cktechsoln.in/" target="_blank"
                    class="text-decoration-none text-white"><strong>CKTech
                        Solution Pvt Ltd.</strong></a></p>
        </div>
    </div>
</div>